export enum PlanListBlocksInteraction {
  FetchAndSetPlans = 'fetch_and_set_plans',
  PlanListPageReady = 'plan_list_page_ready',
  WidgetAdded = 'es_plan_list_blocks_added',
  AssertWidgetExists = 'es_plan_list_blocks_assert_exists',
}
